import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import * as actions from "../../actions";
import FaSpinner from "../../../components/faSpinner/faSpinner";

import { parseOAuthParameters } from "../../constants/parse/oauth";
import dependencies from "../../dependencies";

const { baseUrl, relativeJsonApiLinks } = dependencies;

function Oauth2CallbackHOC(props) {
  const { oAuth, location, loading, loginResponse, isLoggedIn } = props;
  const loginInitiated = useRef(false);
  const awaitingLoginResult = useRef(false);
  const history = useHistory();

  useEffect(() => {
    // The OAuth parameters normally arrive via /login (LoginHOC). If they are
    // missing - a refresh on this page, or a login started by a page that did
    // not go through /login - fetch them here; only redirect_uri is needed.
    if (!oAuth) {
      props.fetchOauthParameters();
    }
  }, [oAuth]);

  useEffect(() => {
    // Only initiate login once when OAuth parameters are available
    if (oAuth && oAuth.parameters && !loginInitiated.current) {
      loginInitiated.current = true;
      let loginUrl = oAuth.parameters.redirect_uri + location.search;
      if (relativeJsonApiLinks) {
        loginUrl = baseUrl + loginUrl;
      }
      props.login({
        url: loginUrl,
      });
    }
  }, [oAuth]);

  useEffect(() => {
    // Redirect only once the login started on THIS page has settled.
    // applicationUser is persisted (redux-persist), so isLoggedIn may already be
    // true from an earlier session when this page mounts; redirecting on that
    // stale value navigated away mid-exchange and aborted the POST that was
    // establishing the new session (seen as "The operation was canceled").
    if (!loginInitiated.current) {
      return;
    }
    if (loading) {
      awaitingLoginResult.current = true;
      return;
    }
    if (!awaitingLoginResult.current) {
      return;
    }
    awaitingLoginResult.current = false;
    if (!isLoggedIn) {
      return; // loginFailed: the error is rendered below
    }
    // Home by default, unless a different app (e.g. Manager) initiated this
    // login and asked to be sent back to it instead.
    const returnTo = sessionStorage.getItem("returnTo");
    if (returnTo) {
      sessionStorage.removeItem("returnTo");
      window.location.href = returnTo;
      return;
    }
    history.push("/");
  }, [loading, isLoggedIn, history]);

  const showError = typeof loginResponse === "string";
  return (
    <div>
      {loading ? (
        <FaSpinner loading />
      ) : showError ? (
        <p
          style={{ textAlign: "center", margin: 30 }}
          dangerouslySetInnerHTML={{ __html: loginResponse }}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.applicationUser?.loading,
  token: state.applicationUser?.token,
  userInfo: state.applicationUser?.userInfo,
  loginResponse: state.applicationUser?.loginResponse,
  isLoggedIn: state.applicationUser?.isLoggedIn,
  oAuth: parseOAuthParameters(state.applicationUser?.oAuthParameters),
});

const mapDispatchToProps = (dispatch) => ({
  login: (userInfo) => {
    dispatch(actions.login(userInfo));
  },
  fetchOauthParameters: () => {
    dispatch(actions.fetchOauthParameters());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Oauth2CallbackHOC);
